// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2xhUe","modalForm":"UpgradeEpcsModal_modalForm__VMDF_","modalFooter":"UpgradeEpcsModal_modalFooter__xPG_Q"};